import styled from "styled-components";
import { px2rem } from "common/helpers/rem";
import { CountIndicatorBox } from "../styledComponents";

const REPLY_PADDING_LEFT = 52;

export const Container = styled.div`
  background-color: ${props => props.theme.grey100};
  padding-top: ${px2rem(8)};
  margin-top: ${px2rem(-8)};
  ${CountIndicatorBox} {
    margin-left: ${px2rem(36)};
  }
`;

export const ReplyInputWrapper = styled.div`
  margin-top: ${px2rem(8)};
`;

export const CollapseButton = styled.button.attrs({
  type: "button",
})`
  display: flex;
  width: 100%;
  height: ${px2rem(50)};
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
`;

export const ReplyContainer = styled.div`
  padding-left: ${px2rem(REPLY_PADDING_LEFT - 16)};
`;
